import * as z from 'zod';

export const prefectureSchema = z.number().min(0).max(48);
